import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading font-bold text-foreground-900 mb-3">
              打屁股漫画大全
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              最全面的惩罚教育漫画场景合集，收录搞笑亲子、校园故事、经典漫画等丰富内容，在欢笑中感受漫画艺术的魅力。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-900 mb-3">分类导航</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-900 mb-3">热门文章</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/article/ming-ren-zhuan-cheng-fa" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">火影忍者成长之路</Link>
              </li>
              <li>
                <Link to="/article/si-ren-zhi-jian-de-tiao-pi-shi" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">哆啦A梦童年趣事</Link>
              </li>
              <li>
                <Link to="/article/longzhu-jingdian-chengfa" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">龙珠经典训练场景</Link>
              </li>
              <li>
                <Link to="/article/mama-shengqi-zenmeban" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">妈妈生气了怎么办</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-900 mb-3">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">品牌介绍</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">联系我们</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">常见问题</Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 打屁股漫画大全 版权所有 | 内容仅供学习交流，原漫画版权归原作者所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}